// import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";
import { lazy, Suspense, useEffect } from "react";
import "aos/dist/aos.css";
import { Toaster } from "react-hot-toast";
import { Routes, Route } from "react-router-dom";
import masterRoutes from "./Router/masterRoutes";

const Sidebar = lazy(() => import("./Components/Sidebar"));

function App() {
  useEffect(() => {
    (async () => {
      const AOS = await import("aos");
      await import("aos/dist/aos.css");
      AOS.init({ duration: 800, easing: "ease-in-out" });
    })();
  }, []);

  return (
    <>
      div.
      <div class="row m-0">
        <div class="col-3">
          <Suspense fallback={"Loading Content"}>
            <Sidebar />
          </Suspense>
        </div>
        <div class="col-8">
          <Suspense fallback={"Loading Content"}>
            <Routes>
              {masterRoutes &&
                masterRoutes.map((route, i) => (
                  <Route path={route.path} element={route.element} />
                ))}
            </Routes>
          </Suspense>
        </div>
      </div>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#222",
            color: "#fff",
          },
        }}
      />
    </>
  );
}

export default App;
